<div class="flex gap-2">
  <app-pan-form-control class="flex-1" data-testid="instanceAtDateContainer">
    <app-pan-floating-label for="instance_at" [required]="true">{{ dateLabel() }}</app-pan-floating-label>
    <app-pan-datepicker
      class="flex-1"
      [color]="color()"
      [disabled]="disabled()"
      [min]="min()"
      [max]="max()"
      [name]="name()"
      [id]="id()"
      [placeholder]="placeholder()"
      [startView]="dateStartView()"
      [date]="dateValue()"
      (dateChange)="onDateChange($event)"
      (invalidDate)="invalidDate.emit()"
      (monthSelected)="dateMonthSelectedHandler($event)"
      (yearSelected)="dateYearSelectedHandler($event)"
    ></app-pan-datepicker>
  </app-pan-form-control>
  <app-pan-form-control class="flex-1" data-testid="instanceAtTimeContainer">
    <app-pan-floating-label for="instance_at_time" [required]="true">{{ timeLabel() }}</app-pan-floating-label>
    <app-pan-timepicker
      class="flex-1"
      [disabled]="disabled()"
      [name]="name()"
      [id]="id()"
      [placeholder]="placeholder()"
      [time]="timeStr()"
      (timeChange)="onTimeChange($event)"
    ></app-pan-timepicker>
  </app-pan-form-control>
</div>
